import styled from 'styled-components';
import { PageHeader } from 'ui/pageHeader';
import { spacing } from 'ui/theme';

export const PageActionWrapper = styled.div`
  display: flex;
  gap: ${spacing.base};
`;

export const StyledPageHeader = styled(PageHeader)`
  margin: ${spacing.plusHalf} 0;
`;
